// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qzZnP {\n  visibility: hidden;\n  width: 0;\n  height: 0;\n  position: absolute;\n  z-index: -1;\n  top: -9999px;\n}\n\n.bNjaw {\n  background-color: var(--color-white);\n}\n\n.sEJPJ {\n  margin-right: var(--spacing-md);\n  max-width: 200px;\n  width: 100%;\n}\n\n.dyl7C {\n  margin-right: unset;\n}\n\n.Ao0fJ {\n  max-width: calc(100% - var(--spacing-xt-md));\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "qzZnP",
	"selectInput": "bNjaw",
	"selectContainer": "sEJPJ",
	"onboarding": "dyl7C",
	"input": "Ao0fJ"
};
export default ___CSS_LOADER_EXPORT___;
